import * as Yup from 'yup';

export const sepulturaValidationSchema = Yup.object().shape({
    id: Yup.number()
        .required('El ID es obligatorio')
        .typeError('El ID debe ser un número válido'),
    
   
});

export const validateSepulturaForm = async (formData) => {
    try {
        await sepulturaValidationSchema.validate(formData, { abortEarly: false });
        return {};
    } catch (error) {
        const errors = {};
        if (error.inner) {
            error.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
        }
        return errors;
    }
};
